import { combineReducers } from 'redux';

import vbtDashboardDataReducer from './vbtDashboardDataReducer';
import vbtDahsboardUiReducer from './vbtDashboardUiReducer';

export default combineReducers({
  data: vbtDashboardDataReducer,
  ui: vbtDahsboardUiReducer,
});
